let autoIncId = 0;
const genId = () => --autoIncId;


export default function (sort_order = 0) {

    return {
        id: genId(),
        description: '',
        sort_order: sort_order
    };
}
